import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BROKER_API = `${BACKEND_URL}/api/broker`;

export const brokerApi = {
  get: (path, params) => axios.get(`${BROKER_API}${path}`, { params }),
  post: (path, body) => axios.post(`${BROKER_API}${path}`, body),
  patch: (path, body) => axios.patch(`${BROKER_API}${path}`, body),
  del: (path) => axios.delete(`${BROKER_API}${path}`),
};
